import type { IconProps } from "../types";

export const Plug = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M12 22v-5" />
    <path d="M15 8V2" />
    <path d="M17 8H7V13a4 4 0 0 0 4 4h2a4 4 0 0 0 4-4Z" />
    <path d="M9 8V2" />
  </svg>
);
